import { render, staticRenderFns } from "./supInteract.vue?vue&type=template&id=0cd28389&scoped=true&"
import script from "./supInteract.vue?vue&type=script&lang=js&"
export * from "./supInteract.vue?vue&type=script&lang=js&"
import style0 from "./supInteract.vue?vue&type=style&index=0&id=0cd28389&lang=less&scoped=true&"
import style1 from "./supInteract.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd28389",
  null
  
)

component.options.__file = "supInteract.vue"
export default component.exports